<div class="table-responsive-custom">
  <table class="table align-middle">
    <thead>
      <tr>
        <th class="bg-table-head text-center"></th>
        <th class="bg-table-head text-start">RUT Empresa</th>
        <th class="bg-table-head text-start">Razón Social</th>
        <th class="bg-table-head text-center">Estado configuración</th>
        <th class="bg-table-head text-center">Opciones</th>
      </tr>
    </thead>
    <tbody>
      @for (item of empresas; track $index) {
      <tr>
        <th [class]="'th-body text-center' + (item.expandidoRow ? ' bg-EFF6FF' : '')">
          <img src="assets/icons/ver-mas.svg" alt="expandir" (click)="toggleRow(item)"
            class="cursor-pointer">
        </th>
        <td [class]="'th-body text-start' + (item.expandidoRow ? ' bg-EFF6FF' : '')">
          <div class="fw-bold">{{ item.rut }}</div>
        </td>
        <td [class]="'th-body text-start' + (item.expandidoRow ? ' bg-EFF6FF' : '')">{{ item.razonSocial }}</td>
        <td [class]="'th-body text-center' + (item.expandidoRow ? ' bg-EFF6FF' : '')">{{ item.estadoConfiguracion ? "Configurada" : "No Configurada" }}
        </td>
        <td [class]="'th-body text-center position-relative' + (item.expandidoRow ? ' bg-EFF6FF' : '')">
          <img src="assets/icons/opciones.svg" alt="expandir" (click)="toggleOpciones(item)"
            class="cursor-pointer">
          @if (item.expandidoOpciones) {
          <div class="contenedor-opciones">
            <button class="btn-opcion d-flex align-items-center gap-2" (click)="editarEmpresa(item.id)">
              <img src="assets/icons/check-configuracion.svg" alt="configurar"
                class="icono-opcion">
              <span>Editar configuración</span>
            </button>
          </div>
          }
        </td>
      </tr>

      @if (item.expandidoRow) {
      <tr>
        <td colspan="5" class="p-0">
          <div class="d-flex flex-column flex-lg-row c-gap-10 px-3 px-md-5 py-3 gap-3">
            <div class="d-flex flex-column">
              <span class="row-expandida-span1">Forma de registrar asistencia:</span>
              <span><img src="assets/icons/bloque-a-bloque-blue.svg" alt="bloque a bloque"> Bloque a bloque</span>
            </div>
            <div class="d-flex flex-column">
              <span class="row-expandida-span1">Método de autenticación:</span>
              <span><img src="assets/icons/e-mail-blue.svg" alt="email"> E-mail</span>
            </div>
            <div class="d-flex flex-column">
              <span class="row-expandida-span1">Método de validación de identidad:</span>
              <span><img src="assets/icons/ninguno-blue.svg" alt="ninguno"> Ninguno</span>
            </div>
          </div>
        </td>
      </tr>
      }
      }
    </tbody>
  </table>
</div>